module.exports = __webpack_public_path__ + "img/04_sub_no.2b80f2ab.svg";